<modal-hoc (modalBackdropClick)="onModalBackdropClick()"></modal-hoc>
